module.exports = __webpack_public_path__ + "static/media/comp-granulating-s.f79814cc.webp";